module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai761-953863ec69a8c2dcf36e429052387ed7.jpg";